module.exports = __webpack_public_path__ + "img/car.2761be2e.png";